import React, { useEffect, useState } from 'react';

import { Fold, Pagination } from '@vlabs/uikit';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { DataWithPaginationPropType, defaultDataWithPagination } from 'helpers/constants';

import st from './Logs.module.sass';

function Logs({
  logsData,
  className,
  fetchData,
  page,
  pageSize,
  setPageSize,
  setPage,
}) {
  const { t } = useTranslation();

  const [isLastPage, setIsLastPage] = useState(false);

  useEffect(() => {
    if (logsData.length === 0) {
      setIsLastPage(true);

      return;
    }

    setIsLastPage(false);
  }, [logsData]);

  const goToPage = (currentPage) => {
    if (page === currentPage) return;
    setIsLastPage(false);
    setPage(currentPage);
  };

  useEffect(() => {
    fetchData({ page: page + 1, page_size: pageSize });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize]);

  return (
    <div className={cn(st.Logs, className)}>
      {!logsData.length && (
        <div className={st.Logs__EmptyMessage}>
          { t('lunaStreamsLogs:пусто') }
        </div>
      )}
      <div className={st.Logs_Wrapper}>
        {Boolean(logsData.length) && logsData.map((log) => (
          <Fold
            className={st.Logs_Fold}
            isOpen={false}
            key={`${log.stream_id} ${log.log_time}`}
            title={(
              <div className={st.LogsItem}>
                <div>
                  {(new Date(log.log_time.replace(',', '.')).toLocaleString('ru-RU'))}
                </div>
                <div>
                  {`${t('lunaStreamsLogs:статус')}: ${log.status}`}
                </div>
                <div>
                  {log.stream_id}
                </div>
              </div>
          )}
          >
            <pre className={st.Logs__Details}>
              {JSON.stringify(log, undefined, 2)}
            </pre>
          </Fold>
        ))}
      </div>

      <div className={st.PaginationWrapper}>
        <Pagination
          canNextPage={!isLastPage}
          canPreviousPage={page !== 0}
          gotoPage={goToPage}
          nextPage={() => setPage(page + 1)}
          pageCount={page + 1}
          pageIndex={page}
          pageSize={pageSize}
          previousPage={() => {
            setIsLastPage(false);
            setPage(page - 1);
          }}
          setPageSize={(size) => setPageSize(size)}
        />
      </div>
    </div>
  );
}

Logs.propTypes = {
  logsData: DataWithPaginationPropType,
  className: PropTypes.string,
  fetchData: PropTypes.func.isRequired,
  setPageSize: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
};

Logs.defaultProps = {
  logsData: defaultDataWithPagination,
  className: undefined,
};

export { Logs };
